import { updateData } from "@shared/actions/user";
import { Button, Spinner } from "@shared/components";
import { useUserState } from "@shared/hooks/user";
import cx from "classnames";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Field, reduxForm, SubmissionError } from "redux-form";

const validateEmail = (value, allValue, props) => {
  const intl = props.intl;
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? intl.formatMessage({
        id: "boilerplate.components.ModalRoom.EmailFillError",
      })
    : undefined;
};

const renderField = (values) => {
  const {
    input,
    label,
    type,
    placeholder,
    meta: { touched, error },
  } = values;
  const formErrorStyle = cx({ form__item_error: !!(touched && error) });

  return (
    <div className={`grid__item_12 form__item ${formErrorStyle}`}>
      <div className="grid__item_4">
        <label className="form__label form__label">{label}</label>
      </div>

      <div className="grid__item_4">
        <input
          {...input}
          type={type}
          className="form__input"
          placeholder={placeholder}
        />

        {touched && error && <div className="form__message">{error}</div>}
      </div>
    </div>
  );
};

const UserDataForm = ({ handleSubmit, change }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const userState = useUserState();
  const { name, displyable_name, remote_id, email, phone } = userState.user;
  const { loading, success } = userState;

  const changeFields = () => {
    change("name", name || displyable_name || remote_id);
    change("email", email);
    change("phone", phone);
  };

  const validateAuth = (values) => {
    const { name, email, phone } = values;

    if (name.length <= 0) {
      throw new SubmissionError({
        name: intl.formatMessage({
          id: "boilerplate.components.Popup.RequireError",
        }),
      });
    }

    dispatch(updateData({ name, email, phone }));
  };

  useEffect(() => {
    changeFields();
  }, []);

  useEffect(() => {
    if (success) {
      changeFields();
    }
  }, [success]);

  let BottomView = (
    <div className="grid__item_7">
      <Button variant="primary" type="submit" tagName="button">
        {intl.formatMessage({
          id: "boilerplate.components.ModalRoom.Settings.UpdateButton",
        })}
      </Button>
    </div>
  );

  if (loading) {
    BottomView = <Spinner />;
  } else if (success) {
    BottomView = (
      <div className="msg msg_success">
        {intl.formatMessage({
          id: "boilerplate.components.ModalRoom.Settings.UpdateDone",
        })}
      </div>
    );
  }

  return (
    <form
      className="form form_horizontal grid"
      onSubmit={handleSubmit(validateAuth)}
    >
      <div className="form__step">
        <Field
          type="text"
          name="name"
          component={renderField}
          label={intl.formatMessage({
            id: "boilerplate.components.ModalRoom.Settings.Name",
          })}
        />
        <Field
          type="email"
          name="email"
          component={renderField}
          label={"E-mail:"}
          validate={[validateEmail]}
        />
        <Field
          type="phone"
          name="phone"
          component={renderField}
          label={intl.formatMessage({
            id: "boilerplate.components.ModalRoom.Settings.Phone",
          })}
        />

        <div className="form__item form__item_divide grid__item_12 grid__item_center">
          <div className="grid__item_4 grid__item_null grid__item_end">
            {BottomView}
          </div>
        </div>
      </div>
    </form>
  );
};

export const UserDataFormView = reduxForm({
  form: "UserDataForm",
})(UserDataForm);
